import cardigan from "../images/cardigan.jpg";
import cargoPants from "../images/cargoPants.jpg";
import cropTop from "../images/cropTop.jpg";
import elegantPants from "../images/elegantPants.jpg";
import hoodie from "../images/hoodie.jpg";
import jeanJacket from "../images/jeanJacket.jpg";
import longCoat from "../images/longCoat.jpg";
import relaxedTee from "../images/relaxedTee.jpg";

const itemData = [
  {
    id: 1,
    pic: cardigan,
    name: "Cardigan",
    price: 47.99,
    quantity: 0,
    added: false,
    priceAPI: "price_1Nj3A2HMqfmkQaKz7uzhDJai",
  },
  {
    id: 2,
    pic: cargoPants,
    name: "Cargo Pants",
    price: 39.99,
    quantity: 0,
    added: false,
    priceAPI: "price_1Nj4SyHMqfmkQaKzZ71Q2QFZ",
  },
  {
    id: 3,
    pic: cropTop,
    name: "Crop Top",
    price: 19.99,
    quantity: 0,
    added: false,
    priceAPI: "price_1Nj4V0HMqfmkQaKzNuPBAejl",
  },
  {
    id: 4,
    pic: elegantPants,
    name: "Elegants",
    price: 54.99,
    quantity: 0,
    added: false,
    priceAPI: "price_1Nj4VUHMqfmkQaKzwlkFxNDQ",
  },
  {
    id: 5,
    pic: hoodie,
    name: "Hoodie",
    price: 29.99,
    quantity: 0,
    added: false,
    priceAPI: "price_1Nj4VpHMqfmkQaKzoz5usJyz",
  },
  {
    id: 6,
    pic: jeanJacket,
    name: "Jean Jacket",
    price: 59.99,
    quantity: 0,
    added: false,
    priceAPI: "price_1Nj4WDHMqfmkQaKzPkyDyx8v",
  },
  {
    id: 7,
    pic: longCoat,
    name: "Long Coat",
    price: 64.99,
    quantity: 0,
    added: false,
    priceAPI: "price_1Nj4WZHMqfmkQaKzB5EdGlsC",
  },
  {
    id: 8,
    pic: relaxedTee,
    name: "Relaxed Tee",
    price: 24.99,
    quantity: 0,
    added: false,
    priceAPI: "price_1Nj4ZJHMqfmkQaKz3yTRc63R",
  },
];

export default itemData;
